import { useTranslation } from 'react-i18next';
import GoToPoDetails from 'src/components/GoToPoDetails';
import { GridColumn } from 'src/components/GridWrapper';
import CommittedAmountDetailCell from 'src/components/custom-cells/CommittedAmountDetailCell';
import CommittedAmountDetailHeaderCell from 'src/components/custom-cells/CommittedAmountDetailHeaderCell';
import PlannedAmountDetailColumnCell from 'src/components/custom-cells/PlannedAmountDetailCell';
import PlannedAmountDetailHeaderCell from 'src/components/custom-cells/PlannedAmountDetailHeaderCell';
import AmountColumn from 'src/sections/view_checkbook/AmountColumn';
import CommittedTotalAmountCell from 'src/sections/view_checkbook/committed_amount_cell/TotalAmountCell';
import DateCell from 'src/sections/view_checkbook/hold_amount_cell/DateCell';
import TotalAmountCell from 'src/sections/view_checkbook/hold_amount_cell/TotalAmountCell';
import Action from 'src/sections/view_checkbook/spent_amount_cell/Action';

export const useHoldAmountColumns = (isPlannedAmount: boolean) => {
  const { t } = useTranslation();
  const holdAmountColumns: GridColumn<any>[] = [
    {
      field: 'expanded',
      width: 45,
      component: isPlannedAmount ? PlannedAmountDetailColumnCell : CommittedAmountDetailCell,
      menu: false,
      headerCell: isPlannedAmount ? PlannedAmountDetailHeaderCell : CommittedAmountDetailHeaderCell,
      sortable: false,
    },
    {
      field: 'date',
      title: 'Date',
      filter: 'date',
      component: DateCell,
      headerCellTooltip: 'Transaction Date',
    },
    {
      field: 'user',
      title: t('Contact'),
      filter: 'text',
      dataType: 'string',
      width: 300,
    },
    {
      field: 'documentNumber',
      title: t('PO #'),
      filter: 'text',
      dataType: 'string',
      component: GoToPoDetails,
    },
    {
      field: 'action',
      title: t('Action'),
      filter: 'text',
      dataType: 'string',
      headerCellTooltip: 'Type of Action',
      component: Action,
    },
    {
      field: 'total',
      title: `$ ${t('Total')}`,
      filter: 'numeric',
      dataType: 'dollar',
      format: '{0:c2}',
      filterFormat: 'c',
      headerCellTooltip: t('Transaction amount for this GL code and period'),
      component: isPlannedAmount ? TotalAmountCell : CommittedTotalAmountCell,
    },
    {
      field: 'poSubject',
      title: t('PO Subject'),
      filter: 'text',
      dataType: 'string',
    },
  ];
  return holdAmountColumns;
};

export const useHoldAmountDetailColumns = () => {
  const { t } = useTranslation();
  const holdAmountDetailColumns: GridColumn<any>[] = [
    {
      field: 'lineItem',
      title: t('Line Item'),
      filter: 'text',
      dataType: 'string',
      menu: false,
    },
    {
      field: 'itemNum',
      title: `${t('Item')} #`,
      filter: 'text',
      dataType: 'string',
      menu: false,
    },
    {
      field: 'description',
      title: t('Description'),
      filter: 'text',
      dataType: 'string',
      menu: false,
    },
    {
      field: 'amount',
      title: t('Amount'),
      filter: 'numeric',
      dataType: 'dollar',
      format: '{0:c2}',
      filterFormat: 'c',
      menu: false,
      component: AmountColumn,
    },
  ];
  return holdAmountDetailColumns;
};
